import { Route } from "react-router-dom";
import { pages } from "../../../utils/common";
import LessonPlanView from "./lessonPlan.view";
import LessonPlanDetailView from "./lessonPlanDetail.view";

const useLessonPlanRoutes = () => (
  <>
    <Route path={pages.lessonPlan.path} element={<LessonPlanView />} />
    <Route
      path={`${pages.lessonPlan.path}/:id`}
      element={<LessonPlanDetailView />}
    />
  </>
);

export default useLessonPlanRoutes;
